import { handleActions } from 'redux-actions';
import Immutable from 'immutable';
import { types as apiActionTypes } from 'actions/apiActions/apiActions';
import { normalize, schema } from 'normalizr';
import config from 'config/config';

export const initialState = Immutable.fromJS({});

export const charitiesSchema = new schema.Entity('charities', {}, {
  idAttribute: 'charityId',
});

export const participantSchema = {
  participant: {
    charities: [charitiesSchema],
  },
};
export const charitySearchSchema = {
  charities: [charitiesSchema],
};

export default handleActions({
  [apiActionTypes.GET_PARTICIPANT_SUCCESS]: (state, action) => {
    let newState = state;

    if (action.response) {
      const normalizedParticipant = normalize({ participant: action.response }, participantSchema);
      newState = newState.mergeDeep({ normalized: normalizedParticipant });
    }

    return newState;
  },

  [apiActionTypes.CHARITY_SEARCH_SUCCESS]: (state, action) => {
    let newState = state;

    if (action.response) {
      const normalizedCharities = normalize({ charities: action.response.charities }, charitySearchSchema);
      newState = newState.setIn(['normalized', 'result', 'charities'], Immutable.List());
      newState = newState.mergeDeep({ normalized: normalizedCharities });
    }

    return newState;
  },

  [apiActionTypes.CREATE_FUNDRAISING_PAGE_SUCCESS]: (state, action) => {
    let newState = state;

    if (action.response) {
      const participant = newState.getIn(['normalized', 'result', 'participant']);
      newState = newState.setIn(['normalized', 'result', 'participant'], participant.merge(action.response));
    }

    return newState;
  },

  [apiActionTypes.CREATE_DONATION_PAGE_SUCCESS]: (state, action) => {
    let newState = state;

    if (action.response && action.response.headers) {
      const encodedLocation = new Buffer(action.response.headers.location).toString('base64');

      newState = newState.setIn(['normalized', 'result', 'participant', 'donationLocation'], `${config.DONATE_URI}/?uri=${encodedLocation}`);
    }

    return newState;
  },

  [apiActionTypes.ADD_CHARITY_ENTITY]: (state, action) =>
    state.setIn(['normalized', 'entities', 'charities', action.charityId], Immutable.fromJS(action.entity)),
}, initialState);



// WEBPACK FOOTER //
// ./reducers/apiReducers/apiReducers.js